import { render } from "./LoadingHandler.vue?vue&type=template&id=05529dae&scoped=true"
import script from "./LoadingHandler.vue?vue&type=script&lang=js"
export * from "./LoadingHandler.vue?vue&type=script&lang=js"

import "./LoadingHandler.vue?vue&type=style&index=0&id=05529dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05529dae"]])

export default __exports__